import * as React from 'react';
import Markdown from 'react-markdown';

import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';

import 'css!bundles/xddp/components/__styles__/homepage/DeadlineInfo';

type DeadlineInfoProps = {
  earlyDeadlineInfo?: string;
  finalDeadlineInfo?: Maybe<string>;
};

const ProgramOverview = ({ earlyDeadlineInfo, finalDeadlineInfo }: DeadlineInfoProps) => {
  if (!earlyDeadlineInfo && !finalDeadlineInfo) {
    return null;
  }

  return (
    <div className="rc-DeadlineInfo rc-Markdown styled">
      {earlyDeadlineInfo && <Markdown className="earlyDeadlineInfo" source={earlyDeadlineInfo} />}
      {finalDeadlineInfo && <Markdown className="finalDeadlineInfo" source={finalDeadlineInfo} />}
    </div>
  );
};

export default ProgramOverview;
